import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { branch, renderNothing } from 'recompose'
import { isNil, clone } from 'ramda'

import T from 'i18n-react'
import { applyUnitsToProps, isValueRisk, hideSpecItem, getCurStatus } from 'helpers/specHelpers'
import SpecItem from 'components/custom/SpecItem/index'
import {
  SPEC_ORDER,
} from 'containers/Project/Specifications/constants'

import styles from './styles.scss'



class CommonSpec extends Component {

  getLabel(moduleName, propertyName){
    if (propertyName) return T.translate(`project.spec.${moduleName}.${propertyName}`)
    return T.translate(`project.spec.${moduleName}.label`)
  }

  getValues(valuesArray){
    if(!valuesArray) return ''
    return valuesArray.reduce((stringSoFar, curValue, index) => {
      if(curValue !== null && curValue.value){
        if(index > 0){
          stringSoFar += ', '
        } 
        stringSoFar += curValue.value
      }
      return stringSoFar;
    }, '')
  }

  renderItems() {
    const {
      moduleName,
      moduleData,
      isModifiedPage,
      curFilter,
    } = this.props
    const moduleOrder = SPEC_ORDER[moduleName]
    
    return moduleOrder.map((property, index) => {
      const propertyData = moduleData[property]
      if (isNil(propertyData)) return

      const {
        initValues,
        modifiedValues,
        risks,
      } = propertyData
      const label = this.getLabel(moduleName, property)
      const risk = risks && modifiedValues && modifiedValues[0] ?
                   isValueRisk(risks, parseFloat(modifiedValues[0].value)) :
                   false
      const initValue = !isModifiedPage ? '' : this.getValues(initValues)
      const modifiedValue = this.getValues(modifiedValues)
      const curStatus = getCurStatus(risk, initValue, modifiedValue)

      // if (hideSpecItem(isModifiedPage, modifiedValue, initValue, risk, curFilter))
      //   return

      return (
        <SpecItem
          key={index}
          label={label}
          initValue={initValue}
          modifiedValue={modifiedValue}
          isModifiedPage={isModifiedPage}
          risk={risk}
          curFilter={curFilter}
          curStatus={curStatus}
        />
      )
    })
    // filter null values
    .filter(val => val)
  }

  render() {
    const { ModuleHeader } = this.props
    const items = this.renderItems()
    const Header = branch(
      () => items.length <= 0,
      renderNothing
    )(ModuleHeader)

    return(
      <div>
        <Header />
        <div styleName='specItemCommon'>
          { items }
        </div>
    </div>
    )
  }
}

export default CSSModules(CommonSpec, styles)
